import React from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import SteamGameStore from '@op/pages/SteamPerformance/components/SteamGameStore';
import SteamScoreTrendBox from '@op/pages/gamestore/widgets/ScoreTrendsPcConsole/SteamScoreTrendBox';
import useGetPcConsoleStats from '@op/pages/gamestore/hooks/useGetPcConsoleStats';
import useGetPcConsoleTimeline from '@op/pages/gamestore/hooks/useGetPcConsoleTimeline';

interface SteamGameStoreSectionProps {
  filter: any;
  onChartClick?: (data: { time: string; sentiment?: 'positive' | 'negative' }) => void;
}

const channel: any[] = ['steam'];

const SteamGameStoreSection: React.FC<SteamGameStoreSectionProps> = ({ filter, onChartClick }) => {
  const { userScore, userScoreLoading } = useGetPcConsoleStats({
    keepParams: filter,
    channel,
    needLink: false,
  });

  const { globalTrendsTimeline, userScoreTrendsLoading } = useGetPcConsoleTimeline({
    keepParams: filter,
    channel,
    formatTimeline: true,
  });

  return (
    <CardCommon loading={userScoreLoading} loadingHeight={300}>
      <SteamGameStore
        title="Added Reviews"
        keys={['select_all_review', 'select_non_recommend', 'select_recommend']}
        data={userScore?.steam || {}}
        filter={filter}
        isSelected={true}
        span={15}
        showShare={false}
        showRatingView={true}
      />
      <SteamScoreTrendBox
        platformData={globalTrendsTimeline?.steam}
        filterParams={filter}
        loading={userScoreTrendsLoading}
        onChartClick={onChartClick}
      />
    </CardCommon>
  );
};

export default SteamGameStoreSection;
